module.exports = __webpack_public_path__ + "static/media/tab_2.f7fc077c.png";